<accredible-responsive-menu
  *transloco="let t; read: 'base-header-menu'"
  [menuTriggerButtonId]="menuTriggerButtonId"
  [dynamicMenuItems]="dynamicMenuItems"
  [staticMenuItems]="staticMenuItems"
  [maxItemHeight]="themeHeaderHeight"
  [redrawObservable]="redrawObservable">
  <ng-template let-menu>
    <button
      mat-button
      id="baseMenuTriggerButton"
      class="btn-header"
      [attr.aria-label]="t('menu_trigger_button_aria_label', { username: user?.name })"
      [matMenuTriggerFor]="menu"
      (click)="onMenuActivated()">
      <accredible-avatar
        *ngIf="user?.name"
        size="28px"
        default-image-header
        [isLoading]="false"
        [imageUrl]="user?.avatar"
        [name]="user?.name">
      </accredible-avatar>

      <span *ngIf="user?.name" class="trigger-hide">{{ user?.name | capitalizeWords }} </span>

      <mat-icon *ngIf="!user" class="burger-no-text">menu </mat-icon>
    </button>
  </ng-template>

  <ng-container *dynamicMenuItems>
    <ng-container *ngFor="let menuItem of dynamicMenuItems">
      <button
        *ngIf="!!menuItem.routerLink; else externalLinkTemplate"
        mat-button
        class="btn-header"
        [routerLink]="menuItem.routerLink"
        [queryParams]="menuItem.queryParams"
        [ngClass]="menuItem.itemClass"
        [disabled]="menuItem.disabled">
        <ng-container *ngIf="menuItem.avatar !== 'none'; else iconTemplate">
          <ng-template *ngTemplateOutlet="avatarTemplate"></ng-template>
        </ng-container>
      </button>

      <ng-template #externalLinkTemplate>
        <a
          *ngIf="menuItem.externalLink | syncOrAsync; else actionTemplate"
          mat-button
          class="btn-header"
          safeShareLink
          [ngClass]="menuItem.itemClass"
          [href]="menuItem.externalLink | syncOrAsync"
          [attr.target]="menuItem?.externalLinkTargetBlank ? '_blank' : null">
          <ng-template *ngTemplateOutlet="iconTemplate"></ng-template>
        </a>
      </ng-template>

      <ng-template #actionTemplate>
        <button
          mat-button
          class="btn-header"
          [ngClass]="menuItem.itemClass"
          [disabled]="menuItem.disabled"
          (click)="menuItem.actionBtn()">
          <ng-container *ngIf="menuItem.avatar !== 'none'; else iconTemplate">
            <ng-template *ngTemplateOutlet="avatarTemplate"></ng-template>
          </ng-container>
        </button>
      </ng-template>

      <ng-template #avatarTemplate>
        <accredible-avatar
          *ngIf="!menuItem.icon; else iconTemplate"
          default-image-header
          class="trailing-margin"
          size="28px"
          [isLoading]="false"
          [imageUrl]="menuItem.avatar">
        </accredible-avatar>
        {{ menuItem.label | syncOrAsync }}
      </ng-template>

      <ng-template #iconTemplate>
        <accredible-icon *ngIf="!!menuItem.icon" [icon]="menuItem.icon"> </accredible-icon>
        {{ menuItem.label | syncOrAsync }}
      </ng-template>
    </ng-container>
  </ng-container>
</accredible-responsive-menu>
